import { ncfAPI } from '../services/api';

const cache = new Map();
let pending = [];
let flushTimer = null;

const flush = async () => {
  const batch = pending;
  pending = [];
  flushTimer = null;
  for (let index = 0; index < batch.length; index += 20) {
    const chunk = batch.slice(index, index + 20);
    try {
      const response = await ncfAPI.validateAddresses(chunk.map(item => item.value));
      chunk.forEach((item, position) => item.resolve(response.data.results?.[position] || null));
    } catch (_error) {
      chunk.forEach(item => {
        cache.delete(item.value);
        item.resolve(null);
      });
    }
  }
};

/** Resolves to the server's validation result, or null if validation is unavailable. */
export const validateAddress = (value) => {
  const text = String(value || '').trim();
  if (!text) return Promise.resolve(null);
  if (cache.has(text)) return cache.get(text);
  const promise = new Promise(resolve => pending.push({ value: text, resolve }));
  cache.set(text, promise);
  if (!flushTimer) flushTimer = setTimeout(flush, 50);
  return promise;
};

export const describeAddressIssue = (result) => {
  if (!result || result.complete) return '';
  if (result.ambiguous) return 'Enter the full address instead of a placeholder.';
  return `Incomplete address: missing ${result.missing.join(', ')}.`;
};
